import { AuthHeader, LoginForm, OTPForm } from './components';
import { Link, useOutletContext } from 'react-router';
import { routes } from '@/lib/constants';
import type { OutletContext } from '@/components/layouts';

export const LoginPage = () => {
  const { step } = useOutletContext<OutletContext>();

  return (
    <div className="flex flex-col gap-10 overflow-y-auto w-full">
      {step === 0 && (
        <AuthHeader
          heading="Welcome Back"
          description="Unlock your potential and turn your passion into profit! Let's start this journey together!"
        />
      )}
      {step === 2 && (
        <AuthHeader
          heading="Verify your email"
          description="Enter the verification code sent to your email"
        />
      )}
      {step === 0 && <LoginForm />}
      {step === 2 && <OTPForm />}
      <div className="text-xs md:text-sm px-4 md:px-6 lg:px-8 -mt-6">
        Don't have any?{' '}
        <Link to={routes.signUp} className="text-primary">
          Create a free account
        </Link>
      </div>
    </div>
  );
};
